<template>
  <section>
    <div class="settings-header">
      {{ __('Créditos SMS') }}
      <button
        class="btn btn-primary ml-auto"
        @click.prevent="create()"
      >
        {{ __('Comprar créditos') }}
      </button>
      <button
        class="btn btn-primary ml-2"
        @click.prevent="create(true)"
        v-if="root"
      >
        {{ __('Adicionar créditos') }}
      </button>
    </div>
    <div class="row">
      <div class="col-12">
        <p class="form-text">
          {{ __('Aqui você pode visualizar a quantidade de SMS disponíveis para enviar') }}.
        </p>
        <div
          class="row"
          v-if="credits.length"
        >
          <div class="col-12">
            <h6>Saldo: {{ Math.floor(totalCredit / SmsPrice) | number(0) }}</h6>
          </div>
          <div class="col-12">
            <ul class="settings-group list-group mt-4">
              <li
                class="list-group-item d-flex align-items-center"
                v-for="credit in credits"
              >
                <span v-if="credit.value >= 0">{{ __('Recarga') }}:<span class="ml-2">{{ Math.floor(credit.value / SmsPrice) | number(0) }}</span></span><span v-else><span v-if="credit.qty > 1">{{ __('Créditos utilizados') }}:</span><span v-else>{{ __('Crédito utilizado') }}:</span><span class="ml-2">{{ credit.qty | number(0) }}</span></span>
                <div class="ml-auto">
                  <span
                    class="date mt-2 mx-2"
                    v-b-tooltip.topright="formatDate(credit.created_at)"
                  ><i class="fa fa-clock-o" /> {{ credit.created_at | ago }}</span>
                </div>
              </li>
            </ul>
          </div>
          <div class="col-12">
            <button
              class="btn btn-primary float-right f-w-500 mt-3"
              @click.prevent="paginate(pagination.current_page + 1)"
              v-if="credits.length && pagination.total != credits.length"
            >
              {{ __('Carregar mais') }}
            </button>
          </div>
        </div>
        <div
          class="row"
          v-else
        >
          <div class="col-12">
            <div class="mt-4">
              <p class="form-text">
                {{ __('Você não tem créditos') }}.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <BModal
      id="credits-root"
      ref="credits-root"
      modal-class="modal-width-380"
      hide-footer="hide-footer"
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Adicionar créditos') }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="closeCreditsRoot"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <form
          class="form"
          role="form"
          @submit.prevent="store(true)"
        >
          <div class="form-group">
            <label>{{ __('Valor') }}</label>
            <input
              class="form-control"
              type="number"
              placeholder="Em centavos"
              v-model="amount"
            >
          </div>
          <div class="d-flex flex-column modal-footer default-modal-footer p-0 mt-3">
            <button
              class="btn btn-primary"
              type="submit"
            >
              {{ __('Adicionar') }}
            </button>
            <button @click="closeCreditsRoot" type="button" class="btn pb-0">
              <u class="btn-cancel">{{ __('Cancelar') }}</u>
            </button>
          </div>
        </form>
      </template>
    </BModal>
    <BModal
      id="credits-modal"
      ref="credits-modal"
      modal-class="modal-width-380"
      hide-footer="hide-footer"
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Comprar créditos') }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="closeCreditsModal"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <form
          class="form"
          role="form"
          @submit.prevent="store"
        >
          <div class="form-group">
            <label>{{ __('Pacote SMS') }}</label>
            <select
              class="form-control w-100"
              v-model="pack"
              required="required"
            >
              <option
                value="value"
                selected="selected"
              >
                {{ __('Selecione o pacote') }}
              </option>
              <option
                :value="index"
                v-for="(pack, value, index) in packs"
              >
                {{ (pack * value / 100) | currency }} - {{ pack }} SMS
              </option>
            </select>
          </div>
          <div class="flex flex-column modal-footer default-modal-footer p-0 mt-3">
            <button
              class="btn btn-primary"
              type="submit"
              :disabled="busy"
            >
              <span v-if="busy"><i class="fa fa-circle-o-notch fa-spin" /> {{ __('Gerando fatura') }}...</span><span v-else>{{ __('Comprar') }}</span>
            </button>
            <button @click="closeCreditsModal" type="button" class="btn pb-0">
              <u class="btn-cancel">{{ __('Cancelar') }}</u>
            </button>
          </div>
        </form>
      </template>
    </BModal>
    <BModal
      id="invoice-modal"
      ref="invoice-modal"
      modal-class="modal-width-380"
      hide-footer="hide-footer"
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Link da fatura') }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="$refs['invoice-modal'].hide()"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <a
          :href="invoice"
          target="_blank"
        >{{ __('Clique aqui para acessar sua fatura') }}</a>
      </template>
    </BModal>
  </section>
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue';
import dayjs from '../../core/dayjs';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  components: {
    BModal,
  },

  props: {
    root: {
      type: Boolean,
      default: false,
    },

    SmsPrice: {
      type: Number,
      required: true,
    },
  },

  data () {
    return {
      pack: '',
      packs: [],
      amount: 0,
      totalCredit: 0,
      credits: [],
      busy: false,
      pagination: {
        current_page: 1,
        total: 0,
      },
      invoice: '',
    };
  },

  created () {
    this.paginate();
    this.getTotal();
    this.getPacks();
  },

  methods: {
    paginate (page = 1, reset = false) {
      if (reset) {
        this.credits = [];
      }

      return this.$http.get(`/credit?page=${page}`)
        .then(({ data: credits }) => {
          const { current_page, total } = credits;
          this.credits.push(...credits.data);
          this.pagination = { current_page, total };
        });
    },

    getTotal () {
      this.$http.get('/credit/total')
        .then(({ data: total }) => this.totalCredit = total);
    },

    getPacks () {
      this.$http.get('/credit/pack')
        .then(({ data: packs }) => this.packs = packs);
    },

    create (add) {
      const ref = this.root && add === true ? 'credits-root' : 'credits-modal';

      this.$refs[ref].show();
    },

    closeCreditsModal () {
      this.$refs['credits-modal'].hide();
    },

    closeCreditsRoot () {
      this.$refs['credits-root'].hide()
    },

    store (add) {
      if (this.busy) {
        return;
      }

      if (add === true) {
        return this.$http.post('/credit/root', { amount: this.amount })
          .then(() => {
            this.$refs['credits-root'].hide();
            this.getTotal();
            this.paginate(1, true);
          });
      }

      this.busy = true;

      this.$http.post('/credit', { pack: this.pack })
        .then(({ data }) => {
          this.busy = false;

          if (! data.url) {
            return Alert.error(this.__('Seu cadastro está incompleto. Contate o suporte para informar os dados restantes.'));
          }

          this.invoice = data.url;
          this.$refs['credits-modal'].hide();
          this.$refs['invoice-modal'].show();
        });
    },

    formatDate (date) {
      return dayjs(date).format('LDT');
    },
  },
};
</script>

<style scoped>
.btn-cancel {
  font-size: 11px;
}
</style>
